module.exports = __webpack_public_path__ + "img/carbon-setting.dd02a2f5.svg";